export const NotificationEnums = {
  getColor: (notificationType) => {
    switch (notificationType) {
      case 1:
        return "#27AE60";
      case 2:
        return "#5153F5";
      case 3:
        return "#DFA479";
      case 4:
        return "#B9B300";
      case 5:
        return "#757575";
      default:
        return "#27AE60";
    }
  },
  getImage: (notificationType) => {
    switch (notificationType) {
      case 1:
        return require("../assets/images/notificationActions/ic_checkin.png");
      case 2:
        return require("../assets/images/notificationActions/ic_requested_checkin.png");
      case 3:
        return require("../assets/images/notificationActions/ic_support_person_action.png");
      case 4:
        return require("../assets/images/notificationActions/ic_negative_feeling.png");
      case 5:
        return require("../assets/images/notificationActions/ic_question.png");
      default:
        return require("../assets/images/notificationActions/ic_checkin.png");
    }
  },
  getAction: (notificationType) => {
    switch (notificationType) {
      case 1:
        return "Check-in";
      case 2:
        return "Contact";
      case 4:
        return "Review";
      case 5:
        return "Answer";
      default:
        return "Check-in";
    }
  },
};
